// Open and close the navigation on small screens.
export default function navToggle() {
    const button = document.querySelector("[data-nav-toggle]");
    if (!button) return;

    button.addEventListener("click", () => {
        const open = document.body.classList.toggle("nav-open");
        button.setAttribute("aria-expanded", open ? "true" : "false");
    });

    // Close the menu if the viewport grows past the mobile breakpoint
    const query = window.matchMedia("(min-width: 768px)");
    query.addEventListener("change", (event) => {
        if (event.matches) {
            document.body.classList.remove("nav-open");
            button.setAttribute("aria-expanded", "false");
        }
    });
}
